export default "__VITE_ASSET__BLU0unWB__"